import { COLOR_CODES_TOOL } from '@quicktools/shared-components';

export const BASE_URL = `${process.env.NX_DEPLOY_PATH}${process.env.NX_DEPLOY_SUFFIX}`;
export const VERSION = process.env.NX_APP_VERSION;

export const TOOL_NAME = COLOR_CODES_TOOL.id;

export const TRACKING_ID = process.env.NX_TRACKING_ID;
export const TRACKING_ID_4 = process.env.NX_TRACKING_ID_4;
export const HOTJAR_ID = Number(process.env.NX_HOTJAR_ID);
export const BUGSNAG_ID = process.env.NX_BUGSNAG_ID;
export const OPTIMIZE_ID = process.env.NX_OPTIMIZE_ID;
export const ONETRUST_ID = process.env.NX_ONETRUST_ID;

export const appText = {
  appName: 'Color Codes',
  main: {
    primaryText: 'Free Color Codes Converter',
    secondaryText:
      'Easily convert color codes to match formatting and specs with the Picsart color code converter tool.',
    colorHeading: 'Color Types',
    pasteTooltip: 'Paste your code here in any format',
  },
  export: {
    option01: 'Copy Link',
    option02: 'Save as PDF',
    option03: 'Get the QR Code',
    copyNotif: 'URL copied to clipboard',
  },
};

export const appConfig = {
  heroBannerImgUrl: 'https://cdn140.picsart.com/06579910455656442956.png',
};
